// extracted by mini-css-extract-plugin
export default {"image":"i3-z","loaded":"j3-z"};